module.exports = __webpack_public_path__ + "img/Vector_folder.30f71b22.svg";